import {
  API_CALL,
  UPDATE_PLACEMENT,
  REQUEST_PLACEMENT,
  RECEIVE_PLACEMENT,
  PLACEMENT_FAILED,
  BEGIN_NEW_PLACEMENT,
  REQUEST_CLONE_PLACEMENTS,
  RECEIVE_CLONE_PLACEMENTS,
  CLONE_PLACEMENTS_FAILED,
  REQUEST_PUSH_PLACEMENTS,
  RECEIVE_PUSH_PLACEMENTS,
  PUSH_FAILED,
  REQUEST_FIX_PLACEMENTS,
  RECEIVE_FIX_PLACEMENTS,
  FIX_FAILED,
  SET_EDIT_PLACEMENTS,
  GO_TO_PLACEMENT,
  REQUEST_CLONE_PLACEMENT,
  CLONE_PLACEMENT_FAILED,
  ADD_PLACEMENTS_TO_ORDER,
  UPDATE_PLACEMENTS_IN_ORDER,
  ADD_OR_UPDATE_PLACEMENTS_IN_ORDER,
  RESET_CLONE_PLACEMENT_STATE,
  DELETE_PLACEMENT,
  RECEIVE_DELETED_PLACEMENT,
  CANCEL_PLACEMENT,
  CANCEL_PLACEMENTS,
  RECEIVE_CANCEL,
  COPY_SETTINGS,
  RECEIVE_COPIED_SETTINGS,
  COPY_SETTINGS_FAILED,
  DELETE_PLACEMENTS,
  RECEIVE_DELETED_PLACEMENTS,
  REQUEST_RESAVE,
  RECEIVE_RESAVE,
  REQUEST_CLEAR_STUFF,
  RECEIVE_CLEAR_STUFF,
  REQUEST_BULK_PLACEMENTS,
  RECEIVE_BULK_PLACEMENTS,
  BULK_PLACEMENTS_FAILED,
  REQUEST_CLEAR_DELETE,
  RECEIVE_CLEAR_DELETE
} from './types';

import { hasError } from './actionHelpers';
import {toast} from "react-toastify";

export const savePlacement = placement => ({
  type: API_CALL,
  onRequest: UPDATE_PLACEMENT,
  onResponse: !!placement.id ? UPDATE_PLACEMENTS_IN_ORDER : ADD_PLACEMENTS_TO_ORDER,
  onError: PLACEMENT_FAILED,
  responseKey: 'placements',
  payload: {
    method: 'POST',
    url: placement.id ? `/placements/${placement.id}` : '/placements/',
    data: placement
  },
  placementId: placement.id || 0,
});

export const saveMultiple = (placements) => ({
  type: API_CALL,
  onRequest: UPDATE_PLACEMENT,
  onResponse: ADD_OR_UPDATE_PLACEMENTS_IN_ORDER,
  onError: PLACEMENT_FAILED,
  responseKey: 'placements',
  payload: {
    method: 'POST',
    url: `/placements/saveMultiple`,
    data: placements
  }
});

export const saveAndNotify = placement => (dispatch, getState) => {
  const infoMsg = `Saving placement ${placement.id || ''}`;
  toast.info(infoMsg, { theme: 'colored', toastId: infoMsg });
  return dispatch(savePlacement(placement))
  .then(() => {
    const err = hasError(getState(), 'orderRequest', dispatch);
    if (err) {
      toast.error(err, { theme: 'colored', toastId: err });
      return;
    }
    const successMessage = `Saved placement ${placement.id || ''}`;
    toast.success(successMessage, { theme: 'colored', toastId: successMessage });
  });
};

export const saveMultipleAndNotify = (placements) => (dispatch, getState) => {
  const infoMsg = `Saving multiple placements`;
  toast.info(infoMsg, { theme: 'colored', toastId: infoMsg });
  return dispatch(saveMultiple(placements))
    .then(() => {
      const err = hasError(getState(), 'placementRequest', dispatch);
      if (err) {
        toast.error('Import failed: ' + err, { theme: 'colored', toastId: err });
        return;
      }
      const successMessage = `Saved ${placements.length} placements`;
      toast.success(successMessage, { theme: 'colored', toastId: successMessage });
    })
};

/**
 * Clone selected placements
 *
 * @param {Array} placementsToClone List of placements
 * @param {int} copiesToMake Number of copies
 */
export const clonePlacements = (placementsToClone, copiesToMake) => {
  return {
    type: API_CALL,
    onRequest: REQUEST_CLONE_PLACEMENTS,
    onResponse: RECEIVE_CLONE_PLACEMENTS,
    onError: CLONE_PLACEMENTS_FAILED,
    payload: {
      method: 'POST',
      url: '/placements/cloneselected',
      data: {
        placements: placementsToClone,
        times: copiesToMake
      }
    }
  };
};

/**
 * Clone one placement with possibility of cloning multiple times
 *
 * @param {int} id Placement id
 * @param {Object} newPlacementSettings Cloning settings
 */
export const clonePlacement = (id, newPlacementSettings) => {
  return {
    type: API_CALL,
    onRequest: REQUEST_CLONE_PLACEMENT,
    onResponse: ADD_PLACEMENTS_TO_ORDER,
    onError: CLONE_PLACEMENT_FAILED,
    responseKey: 'placements',
    payload: {
      method: 'POST',
      url: `/placements/${id}/clone`,
      data: { id, newPlacementSettings }
    }
  };
};

export const getPlacement = id => ({
  type: API_CALL,
  onRequest: REQUEST_PLACEMENT,
  onResponse: RECEIVE_PLACEMENT,
  onError: PLACEMENT_FAILED,
  responseKey: 'placement',
  payload: {
    method: 'GET',
    url: `/placements/${id}`
  },
  placementId: id
});

export const pushPlacements = (ioId, placementIds, pushRules) => ({
  type: API_CALL,
  tracking: true,
  onRequest: REQUEST_PUSH_PLACEMENTS,
  onResponse: RECEIVE_PUSH_PLACEMENTS,
  onError: PUSH_FAILED,
  payload: {
    method: 'POST',
    url: '/placements/pushMultiple',
    data: { ioId: ioId, placementIds: placementIds.join(), pushRules: pushRules }
  }
});

export const saveAndPushPlacements = () => ({
  type: API_CALL,
  tracking: true,
  onRequest: REQUEST_BULK_PLACEMENTS,
  onResponse: RECEIVE_BULK_PLACEMENTS,
  onError: BULK_PLACEMENTS_FAILED,
  payload: {
    method: 'POST',
    url: '/placements/saveAndPushPlacements',
  }
});

export const clearOldStuff = () => ({
  type: API_CALL,
  onRequest: REQUEST_CLEAR_STUFF,
  onResponse: RECEIVE_CLEAR_STUFF,
  onError: FIX_FAILED,
  payload: {
    method: 'POST',
    url: '/placements/clearOldStuff',
  }
});

export const clearSubcat = () => ({
  type: API_CALL,
  onRequest: REQUEST_CLEAR_DELETE,
  onResponse: RECEIVE_CLEAR_DELETE,
  onError: FIX_FAILED,
  payload: {
    method: 'POST',
    url: '/placements/clearDeletes',
  }
});

export const fixPlacements = (placementIds, field, value) => ({
  type: API_CALL,
  onRequest: REQUEST_FIX_PLACEMENTS,
  onResponse: RECEIVE_FIX_PLACEMENTS,
  onError: FIX_FAILED,
  payload: {
    method: 'POST',
    url: '/placements/fixField',
    data: { placementIds: placementIds.join(), field: field, value: value }
  }
});

export const fixPubs = () => ({
  type: API_CALL,
  onRequest: REQUEST_RESAVE,
  onResponse: RECEIVE_RESAVE,
  onError: FIX_FAILED,
  payload: {
    method: 'POST',
    url: '/placements/fixPubs',
  }
});

export const fixName = () => ({
  type: API_CALL,
  onRequest: REQUEST_RESAVE,
  onResponse: RECEIVE_RESAVE,
  onError: FIX_FAILED,
  payload: {
    method: 'POST',
    url: '/placements/fixName',
  }
});

export const fixAmid = (amid, placement) => ({
  type: API_CALL,
  onRequest: REQUEST_RESAVE,
  onResponse: RECEIVE_RESAVE,
  onError: FIX_FAILED,
  payload: {
    method: 'POST',
    url: '/placements/fixAmid',
    data: { amid: amid, placement: placement }
  }
});

export const setPlacement = placement => ({
  type: RECEIVE_PLACEMENT,
  placement
});

export const setError = error => ({
  type: PLACEMENT_FAILED,
  error
});

export const setEditList = ids => ({
  type: SET_EDIT_PLACEMENTS,
  ids
});

export const beginNewPlacement = () => ({
  type: BEGIN_NEW_PLACEMENT
});

export const goToPlacement = idx => ({
  type: GO_TO_PLACEMENT,
  value: idx
});

export const clonePlacementWithNotifications = (id, newPlacementsSettings) => (dispatch, getState) => {
  const infoMsg = `Cloning placement ${id} with new settings ${newPlacementsSettings.length}`;
  toast.info(infoMsg, { theme: 'colored', toastId: infoMsg });
  return dispatch(clonePlacement(id, newPlacementsSettings)).then((/* dispatched */) => {
    const err = hasError(getState(), 'placementRequest', dispatch);
    if (err) {
      toast.error(err, { theme: 'colored', toastId: err });
      return
    }
    const { clonedPlacements } = getState().placementRequest;
    const successMessage = `Successfully cloned ${clonedPlacements.length} Placements`;
    toast.success(successMessage, { theme: 'colored', toastId: successMessage });
  });
};

export const resetClonePlacementState = () => ({
  type: RESET_CLONE_PLACEMENT_STATE
});

export const deletePlacement = (id) => ({
  type: API_CALL,
  onRequest: DELETE_PLACEMENT,
  onResponse: RECEIVE_DELETED_PLACEMENT,
  onError: PLACEMENT_FAILED,
  payload: {
    method: 'DELETE',
    url: `/placements/${id}`
  }
});

export const deletePlacements = (ids) => {
  return {
    type: API_CALL,
    onRequest: DELETE_PLACEMENTS,
    onResponse: RECEIVE_DELETED_PLACEMENTS,
    onError: PLACEMENT_FAILED,
    payload: {
      method: 'POST',
      url: `/placements/deletes`,
      data: { placements: ids }
    }
  }
};

export const cancelPlacement = (id) => ({
  type: API_CALL,
  onRequest: CANCEL_PLACEMENT,
  onResponse: RECEIVE_CANCEL,
  onError: PLACEMENT_FAILED,
  payload: {
    method: 'POST',
    url: `/placements/${id}/cancel`
  }
});

export const cancelPlacements = (ids) => {
  return {
    type: API_CALL,
    onRequest: CANCEL_PLACEMENTS,
    onResponse: RECEIVE_CANCEL,
    onError: PLACEMENT_FAILED,
    payload: {
      method: 'POST',
      url: `/placements/cancelMultiple`,
      data: { placements: ids }
    }
  }
};

export const copySettings = (id, targetPlacementIds, updates) => ({
  type: API_CALL,
  onRequest: COPY_SETTINGS,
  onResponse: RECEIVE_COPIED_SETTINGS,
  onError: COPY_SETTINGS_FAILED,
  payload: {
    method: 'POST',
    url: `/placements/${id}/copysettings`,
    data: { id, targetPlacementIds, updates }
  }
});
